import * as React from "react";

const InfoCircleIcon: React.FC = () => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <circle cx="8" cy="8" r="6.5" />
            <line x1="8" y1="7.4" x2="8" y2="11.2" />
            <line x1="8" y1="4.8" x2="8" y2="4.8" />
        </svg>
    );
};

export default React.memo(InfoCircleIcon);
